import { defineMessages } from "react-intl";

const PREFIX = "ContactPage";
export default defineMessages({
  name: {
    id: `${PREFIX}.name`,
    defaultMessage: "Ivan Zlatkovic",
  },
  position: {
    id: `${PREFIX}.position`,
    defaultMessage: "APM/MI - Market Intelligence",
  },
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Contact author",
  },
  subtitle: {
    id: `${PREFIX}.subtitle`,
    defaultMessage: "If you need assistance with AP Agriculture Terminal, please contact:",
  },
});
